class Url {
  constructor() {
    this.url = window.location.href;
  }

  getAll() {
    var params = {};
    var search = decodeURIComponent(this.url.slice(this.url.indexOf("?") + 1));
    var definitions = search.split("&");

    definitions.forEach(function(val) {
      var parts = val.split("=", 2);
      params[parts[0]] = parts[1];
    });

    return params;
  }

  get(property) {
    let params = this.getAll();
    return property && property in params ? params[property] : null;
  }

  exists(property) {
    let params = this.getAll();
    return property && property in params;
  }
}

export default Url;
